import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const GatewaySettingsFeature: FeatureMetadata = {
  id: "gateway-settings",
  moduleName: "feesFinance",
  navigation: {
    label: "Gateway Settings",
    path: "/gateway-settings",
    icon: AdjustmentsHorizontalIcon,
    order: 6,
  },
  route: {
    path: "/gateway-settings",
    element: lazy(() => import("./pages/PaymentGatewaySettings")),
  },
  permissions: buildCrudPermissions("FeeFinance", "OnlinePayments", {
    view: permissionId("FeeFinance", "OnlinePayments", "manageSettings"),
    create: permissionId("FeeFinance", "OnlinePayments", "manageSettings"),
    edit: permissionId("FeeFinance", "OnlinePayments", "manageSettings"),
    delete: permissionId("FeeFinance", "OnlinePayments", "manageSettings"),
  }),
  readiness: "live",
};
